export default __webpack_public_path__ + "static/media/input-cancle-image.a58626c1.svg";